class RoutePerformanceController {
    /*@ngInject*/
    constructor($state) {
        this.$state = $state;
        this.id = "route_performance";
        this.acl = {};
        this.hasACL = {};
    }

    $onInit() {
        for (let key in this.acl['reporting_' + this.id]) {
            this.hasACL[this.acl['reporting_' + this.id][key]] = true;
        }
    }
}

export default RoutePerformanceController;


// WEBPACK FOOTER //
// ./client/app/components/reporting/components/route_performance/route_performance.controller.js